import {Injectable} from '@angular/core';
import {Http, XHRBackend, RequestOptions, Request, RequestOptionsArgs, Response, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
const tokenBTCustomerAPI :string = 'tokenBTCustomerAPI';
@Injectable()
export class HttpServiceProvider extends Http {

  constructor (backend: XHRBackend, options: RequestOptions) {
    let token = localStorage.getItem(tokenBTCustomerAPI); // your custom token getter function here
    options.headers.set('Authorization', `Bearer ${token}`);
    super(backend, options);
  }

  request(url: string|Request, options?: RequestOptionsArgs): Observable<Response> {
    let tokenBTCustomer = localStorage.getItem(tokenBTCustomerAPI);
    // console.log('token at httpservice:',token);
    if (typeof url === 'string') { // meaning we have to add the token to the options, not in url
      if (!options) {
        // let's make option object
        options = {headers: new Headers()};
      }
      console.log('http:',url);
      if (url.indexOf("tmsapi") > -1 || url.indexOf("tms/api") > -1) {
        options.headers.set('Authorization', 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI1NzBmOGUzN2U0YjBjYmNkMDk1ZDk2Y2EiLCJ1c2VybmFtZSI6ImFkbWluIiwiZW1haWwiOiJhZG1pbkBib290aHRyYW5zcG9ydC5jb20iLCJkaXNwbGF5TmFtZSI6IkFkbWluIiwiRGVwb3QiOiJWaWxsYXdvb2QiLCJlbXBsb3llZU51bWJlciI6IjExMTExIiwiaWF0IjoxNDgyMjk2OTEzfQ.LV0ZOvyhbErEl3i2whdjhcLh8X0pNNZvJ2Q1PkPwgGA');
      } else {
        if (tokenBTCustomer) {
          options.headers.set('Authorization', `Bearer ${tokenBTCustomer}`);
        }
      }
    } else {
    // we have to add the token to the url object
      if (url.url.indexOf("tmsapi") > -1 || url.url.indexOf("tms/api") > -1) {
        url.headers.set('Authorization', 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI1NzBmOGUzN2U0YjBjYmNkMDk1ZDk2Y2EiLCJ1c2VybmFtZSI6ImFkbWluIiwiZW1haWwiOiJhZG1pbkBib290aHRyYW5zcG9ydC5jb20iLCJkaXNwbGF5TmFtZSI6IkFkbWluIiwiRGVwb3QiOiJWaWxsYXdvb2QiLCJlbXBsb3llZU51bWJlciI6IjExMTExIiwiaWF0IjoxNDgyMjk2OTEzfQ.LV0ZOvyhbErEl3i2whdjhcLh8X0pNNZvJ2Q1PkPwgGA');
      } else {
        if (tokenBTCustomer) {
          url.headers.set('Authorization', `Bearer ${tokenBTCustomer}`);
        }
      }
    }
    return super.request(url, options).catch(this.catchAuthError(this));
  }

  private catchAuthError (self: HttpServiceProvider) {
    // we have to pass HttpServiceProvider's own instance here as `self`
    return (res: Response) => {
      if (res.status === 401 || res.status === 403 || res.status === 404) {      
        
        // window.localStorage.clear();        
        // window.location.reload()
      }
      return Observable.throw(res);
    };
  }
}



// WEBPACK FOOTER //
// ./src/providers/http-service/http-service.ts